export default {
  "content": "<path d=\"M3.147 1.778c.053.79.186 1.564.4 2.302L2.48 5.147a13.178 13.178 0 01-.676-3.37h1.343zm8.764 10.684a11.33 11.33 0 002.311.4v1.325a13.711 13.711 0 01-3.378-.667l1.067-1.058zM4 0H.889C.4 0 0 .4 0 .889 0 9.236 6.764 16 15.111 16c.489 0 .889-.4.889-.889V12.01c0-.489-.4-.889-.889-.889-1.102 0-2.178-.178-3.173-.507a.748.748 0 00-.276-.044.91.91 0 00-.63.258l-1.956 1.955a13.465 13.465 0 01-5.858-5.858L5.173 4.97a.892.892 0 00.223-.907A10.098 10.098 0 014.889.89C4.889.4 4.489 0 4 0z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};